import { createContext } from "@lit/context";
import type { Theme, RatingConfig } from "./models";

export const themeContext = createContext<Theme>("theme");
export const configContext = createContext<RatingConfig>("config");
export const lockedContext = createContext<boolean>("locked");
